import { appConfig } from "@/guards/auth/azure-b2c.config";

const BASE_PROTOCOL = "https";

export const BASE_URL = `${BASE_PROTOCOL}://${appConfig?.API_BASE_URL}`;
